var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-alert',{attrs:{"type":"error","center":"","show-icon":false}},[_c('div',{staticClass:"h3"},[_vm._v("This page is currently in development.")])])}
var staticRenderFns = []

export { render, staticRenderFns }